import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App.tsx";
import "./i18n/index.ts";
// Avant tout affichage : Chrome peut proposer l'installation dès le chargement (beforeinstallprompt).
import "./lib/install.ts";
import { persister, queryClient } from "./lib/queryClient.ts";
import { initSession } from "./lib/session.ts";
import "./styles.css";

initSession();
// Base hors ligne (Dexie) chargée juste après le premier affichage : hors du budget JS initial.
void import("./offline/storage.ts").then((m) => m.ensurePersistentStorage());
void import("./offline/sync.ts").then((m) => m.startSyncLoop());

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister, maxAge: 7 * 24 * 3600_000 }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistQueryClientProvider>
    </StrictMode>,
  );
}
